import postWithToken from './base/post-with-token'

const sendMailUpdateAddress = (data) => postWithToken(`/customer-overview/send-mail-update-address`)({data})

export default sendMailUpdateAddress